import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { AuthContext } from '../../../App/App';
import { WhatsappContext } from './Whatsapp';
import { ContentBodyContext } from '../MainContent';
import jwt from 'jwt-decode'


function ChatModalAttachment() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    //ataachment value
    const initalDataAttach = {
        file: null,
        desc: '',
        err: null,
        isSubmitting: false
    }
    const [dataAttach, setdataAttach] = useState(initalDataAttach)
    const handleAttachDescChange = (event) => {
        event.preventDefault()
        setdataAttach({
            ...dataAttach,
            desc: event.target.value
        })
    }

    const handleAttchClick = () => {
        dispatchWhatsApp({
            type: "MODALATTACH",
            modalattach: {
                status: false,
            }
        })
        setdataAttach(initalDataAttach)
    }

    const handleAttachFileChange = (event) => {
        event.preventDefault()
        if (event.target.files[0] !== undefined) {
            setdataAttach({
                ...dataAttach,
                file: event.target.files[0],
                err: event.target.files[0].size > (2 * 1048576) ? 'Maximal attachment is 2MB.' : null
            })
        }
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(","));
        reader.onerror = error => reject(error);
    });

    //attachment submit
    const handleAttachSubmit = async (event) => {
        event.preventDefault();
        if (dataAttach.file != null && dataAttach.err === null && dataAttach.isSubmitting === false) {
            setdataAttach({
                ...dataAttach,
                isSubmitting: true
            })
            const file = await toBase64(dataAttach.file)
            stateContentBody.socket.emit('whatsapp-chat', {
                id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id,
                token: localStorage.getItem('token-helpdesk-umy'),
                body: {
                    action: 'attachment',
                    file: {
                        mime: dataAttach.file.type,
                        data: file[1],
                        name: dataAttach.file.name
                    },
                    receiver: stateWhatsApp.chats.find(chat => chat.id == stateWhatsApp.active).phone,
                    message: dataAttach.desc,
                }
            })
        } else {
            setdataAttach({
                ...dataAttach,
                err: 'Please select attachment'
            })
        }
    }

    useEffect(() => {
        if (stateWhatsApp.trigger.message == 'whatsapp-chat') {
            if (stateWhatsApp.trigger.status == 'success') {
                handleAttchClick();
            } else {
                setdataAttach({
                    ...dataAttach,
                    isSubmitting: false
                })
            }
        }
    }, [stateWhatsApp.trigger])

    //render modal view
    const [renderModal, setRenderModal] = useState(<Fragment />)
    useEffect(() => {
        if (stateWhatsApp.modalattach.status == true) {
            setRenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={stateWhatsApp.modalattach.status} backdrop={'static'} keyboard={true} >
                        <ModalHeader toggle={handleAttchClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            Send File
                            <i style={{ fontSize: '18px', color: 'blue', paddingLeft: '7px' }} className="fas fa-question-circle" id="help-attach"></i>
                            <UncontrolledTooltip placement="right" target="help-attach">
                                <div className="p-0">
                                    <table>
                                        <tr>
                                            <th>File</th>
                                            <th>Max Size</th>
                                        </tr>
                                        <tr>
                                            <td>Audio</td>
                                            <td>2 MB</td>
                                        </tr>
                                        <tr>
                                            <td>Document</td>
                                            <td>2 MB</td>
                                        </tr>
                                        <tr>
                                            <td>Image</td>
                                            <td>2 MB</td>
                                        </tr>
                                        <tr>
                                            <td>Video</td>
                                            <td><b style={{ color: 'red' }}>Not Support</b></td>
                                        </tr>
                                    </table>
                                </div>
                            </UncontrolledTooltip>
                        </ModalHeader>
                        <ModalBody>
                            <form className="needs-validation">
                                <div className="form-group row">
                                    <label htmlFor="file" className="col-form-label">Choose File</label>
                                    <div className="input-group  has-validation">
                                        <input type="file" className={`form-control ${dataAttach.err != null ? 'is-invalid' : ''}`} id="file" name="file" autoFocus onChange={handleAttachFileChange} aria-describedby="validationInput" />
                                        <div id="validationInput" className="invalid-feedback">
                                            <small>{dataAttach.err}</small>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleAttachSubmit} style={{ textTransform: 'capitalize' }} disabled={dataAttach.file == null ? true : (dataAttach.isSubmitting)}>{dataAttach.isSubmitting ? '...uploading' : 'Send'} <i className={dataAttach.isSubmitting ? 'fas fa-spinner fa-pulse' : "fas fa-paper-plane"}></i></Button>
                            <Button color="secondary" onClick={handleAttchClick} style={{ textTransform: 'capitalize' }}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else {
            setRenderModal(<Fragment />)
        }
    }, [stateWhatsApp.modalattach, dataAttach])

    return (
        renderModal
    )
}

export default ChatModalAttachment
